import { LangLocale } from '@myre/common-i18n';
import { assertUnreachable } from '@myre/common-primitives';

import { type MatDateFormats } from '@angular/material/core';

export function monthPickerFormatsFactory(
  langLocale: LangLocale,
): MatDateFormats {
  switch (langLocale) {
    case LangLocale.En: {
      return {
        parse: {
          dateInput: ['MM/dd/yyyy', 'MM dd yyyy', 'MM.dd.yyyy', 'MM-dd-yyyy'],
        },
        display: {
          dateInput: 'MM/dd/yyyy',
          monthYearLabel: 'MMMM yyyy',
          dateA11yLabel: 'MM/dd/yyyy',
          monthYearA11yLabel: 'MMMM yyyy',
        },
      };
    }
    case LangLocale.EnUk:
    case LangLocale.De:
    case LangLocale.Es:
    case LangLocale.Fr: {
      return {
        parse: {
          dateInput: ['dd/MM/yyyy', 'dd MM yyyy', 'dd.MM.yyyy', 'dd-MM-yyyy'],
        },
        display: {
          dateInput: 'dd/MM/y',
          monthYearLabel: 'MMMM y',
          dateA11yLabel: 'dd/MM/y',
          monthYearA11yLabel: 'MMMM y',
        },
      };
    }
    default: {
      assertUnreachable(langLocale);
    }
  }
}
